import React, { useState } from 'react';
import Footer from '../Pages/Footer';
import { Toaster, toast } from 'react-hot-toast';
import SEO from '../components/SEO.jsx';
import { API_URL } from '../config/api';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

 const SubmitForm = async (event) => {
  event.preventDefault();

  if (!name || !email || !number || !content) {
    toast.error("Tous les champs sont obligatoires !");
    return;
  }

  if (loading) return; // 🔒 sécurité anti double clic

  setLoading(true); // ⏳ début du loader

  const data = { name, email, number, content };

  try {
    const response = await fetch(`${API_URL}/email`, {
      method: "POST",
      headers: { 'Content-Type': "application/json" },
      body: JSON.stringify(data)
    });

    const result = await response.json();

    if (response.ok) {
      toast.success("✅ Email envoyé avec succès !!!");
      setName('');
      setEmail('');
      setNumber('');
      setContent('');
    } else {
      toast.error(result.message || "Une erreur est survenue.");
    }
  } catch (error) {
    toast.error("Erreur de connexion au serveur.");
    console.error(error);
  } finally {
    setLoading(false); // ✅ fin du loader (succès ou erreur)
  }
};

  return (
    <div>
      <SEO
        title="Contact"
        description="Contactez l'équipe CodeShop225 pour toute question sur vos commandes, jeux vidéo ou cartes PSN/iTunes."
        path="/contact"
      />
      <Toaster position="top-right" reverseOrder={false} />
      <div className="main--contact">
        <h1 className='header__contact'>Contactez-nous</h1>
        <h5 className='header__contact'>Remplissez notre formulaire de contact</h5>
        <div className="main--contact--content">
          <div className="main--contact--content--left">
            <div className='form__container'>
              <form onSubmit={SubmitForm}>
                <div className="mb-3">
                  <label className="form-label">Nom complets</label>
                  <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Numéro de téléphone</label>
                  <input type="text" className="form-control" placeholder="Numéro de téléphone" value={number} onChange={(e) => setNumber(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Votre message</label>
                  <textarea className="form-control" rows="3" value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                </div>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Envoi en cours..." : "Envoyer"}
                  </button>
              </form>
            </div>
          </div>
          <div className="main--contact--content--right">
            <div className='main--contact--content--right--box'>
              <p>Aidez-nous à mieux comprendre vos besoins</p>
              <p><i className="fa-solid fa-location-dot"></i> Cocody Palmeraie</p>
              <p><i className="fa-solid fa-envelope"></i> infos@codeshop225.ci</p>
              <p><i className="fa-brands fa-whatsapp"></i> +225 01 01 88 59 81 </p>
              <p><i className="fa-solid fa-globe"></i> www.codeshop225.ci</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}